import { format } from 'date-fns';

export function getCurrentIso8601DateTime(): string {
  return format(new Date(), "yyyy-MM-dd'T'HH:mm:ss+00:00");
}
